<template>
    <main id="content" class="sma-about-content">
        <div class="container">
            <div class="link-page">
                <div class="breacrump">
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/" class="link-home">
                            <span itemprop="title">{{ $t("app.Home") }}</span>
                        </router-link>
                        <span class="slashes-link">/</span>
                    </div>
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/we-talk-about-us" itemprop="url">
                            <span itemprop="title">{{
                                $t("app.On parle de nous")
                            }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <h2 class="sma-title-about font-balo">
                {{ $t("app.On parle de nous") }}
            </h2>
            <div class="sma-list-about" v-if="weTalkAboutUs.length > 0">
                <div
                    class="sma-it-about font-bai"
                    v-for="(item, index) in weTalkAboutUs"
                    :key="index"
                >
                    <img :src="item.image" alt="" />
                    <h3>
                        <a href="#" @click.prevent>{{ item.title }}</a>
                    </h3>
                    <p v-html="item.content"></p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "WeTalkAboutUsPage",
    mounted() {
        this.getWeTalkAboutUs();
        let pageId = 245;
        if (this.lang === "en") {
            pageId = 359;
        }
        this.getPage(pageId).then(() => {
            setDescriptionPage(get(this.page, "acf.meta_description", ""));
        });
    },
    computed: {
        ...mapState({
            page: state => get(state, "app.page", {}),
            weTalkAboutUs: state => get(state, "app.weTalkAboutUs", []),
            lang: state => get(state, "app.lang", "fr")
        })
    },
    methods: {
        ...mapActions("app", ["getWeTalkAboutUs", "getPage"])
    }
};
</script>
